module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Preview":"Vorschau"}}')
  delete Component.options._Ctor
}
